<script setup lang="ts">
import type { PropType } from 'vue';
import { classname } from '@/js/utils.ts';

type ButtonType = 'button' | 'submit';
type ButtonTheme = 'primary' | 'accent' | 'secondary';

defineProps({
  type: {
    type: String as PropType<ButtonType>,
    default: 'button',
  },
  theme: {
    type: String as PropType<ButtonTheme>,
    default: null,
  },
  to: {
    type: String,
    default: null,
  },
});

const cn = classname('base-button');
</script>

<template>
  <a v-if="to" :href="to" :class="cn({ type: theme })">
    <slot />
  </a>
  <button v-else :type :class="cn({ type: theme })">
    <slot />
  </button>
</template>
